import { BrowserRouter, Route, Router, Routes } from 'react-router-dom';
import "../assets/index.css"

import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Features from '../components/Features.jsx';
import Testimonial from '../components/Testimonial';
import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';

function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <Features />
      <Testimonial />
      <CallToAction />
      <Footer />
    </>
  );
}

export default Home;
